/* eslint-disable no-use-before-define,no-empty-pattern */
// import { jsx } from '@emotion/core'
import React from 'react'
import { hideModal, Loading, show, } from '../../twd'
import useOrderDetail from './use-order-detail'
import { Detail } from './detail'
import './order-detail-modal.css'

export default ({orderNo, action:action_='', isNote:isNote_=false} = {}) => {

    const { status, detail, action,isNote, title} = useOrderDetail({orderNo, action:action_, isNote:isNote_})
    const [ note, setNote ] = React.useState('')

    const message = {
        'cancel': 'This is a cancel request and must be reviewed and approved before taking effect.',
    }[action]

    const button = {
        'cancel': 'Request Cancel Order',
        'accept': 'Accept',
        'accept-buy': 'Accept',
        'accept-sell': 'Accept'
    }[action]

    const buttonAction = {
        'cancel': 'cancel',
        'accept': 'accept',
        'accept-buy': 'accept',
        'accept-sell': 'accept'
    }[action]

    return <React.Fragment>
    <div className="modal-dialog modal-lg order-detail-modal">
    <div className="modal-content">
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row"><div className="col-md-12">
        <div className="vertical-offset-md"></div>
        <button
            className="close"
            aria-label="close"
            data-name="order-detail-close-button"
            type="button"
            onClick={() => {
                hideModal()
            }}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>
    </div></div>

    <div className="row">
        <div className="col-md-12 text-center">
            <h2><b>{title}</b></h2>
        </div>
    </div>

    <Loading status={status}>
        {message && <React.Fragment>
            <div className="row"><div className="col-xs-12">
            <div data-name="messages-message"
                className="universal-message universal-message-info universal-message-dismissible"
                role="alert">
                <div data-name="messages-message-content"
                    className="universal-message-content"
                    style={{width:'100%'}}
                >{message}</div>
            </div>
            </div></div>
        </React.Fragment>}

        <Detail detail={detail} note={note} setNote={setNote} isNote={isNote} />

        {button && <React.Fragment>
            <div className='row'>
            <div className="col-md-6 text-center" style={{float:'none', margin:'0 auto'}}>
            <button
                aria-label="Request Cancel Order"
                data-name="order-detail-cancel-order-button"
                className="btn btn-primary btn-block"
                type="button"
                onClick={() => {
                    hideModal()
                    show('orders-confirm', {
                        action: buttonAction,
                        orderNo,
                        cusip: detail.cusip,
                        acctNo: detail['account#'],
                        note,
                    })
                }}
            >{button}</button>
            </div>

            </div>
        </React.Fragment>}

    </Loading>


    </div>
    </div>
    </div>

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/orders/modal/order-detail-modal.js